/*-----/translation api/------*/
export const FETCH_TRANS_PENDING = "FETCH_TRANS_PENDING";
export const FETCH_TRANS_REJECTED = "FETCH_TRANS_REJECTED";
export const FETCH_TRANS_FULFILLED = "FETCH_TRANS_FULFILLED";
/*-----/constraints api/------*/
export const FETCH_CONSTRAINTS = "FETCH_CONSTRAINTS";
export const FETCH_CONSTRAINTS_PENDING = "FETCH_CONSTRAINTS_PENDING";
export const FETCH_CONSTRAINTS_REJECTED = "FETCH_CONSTRAINTS_REJECTED";
export const FETCH_CONSTRAINTS_FULFILLED = "FETCH_CONSTRAINTS_FULFILLED";
/*-----/formation api/------*/
export const FETCH_FIXTURES = "FETCH_FIXTURES";
export const FETCH_FIXTURES_PENDING = "FETCH_FIXTURES_PENDING";
export const FETCH_FIXTURES_REJECTED = "FETCH_FIXTURES_REJECTED";
export const FETCH_FIXTURES_FULFILLED = "FETCH_FIXTURES_FULFILLED";
/*-----/players api/------*/
export const FETCH_PLAYERS = "FETCH_PLAYERS";
export const FETCH_PLAYERS_PENDING = "FETCH_PLAYERS_PENDING";
export const FETCH_PLAYERS_REJECTED = "FETCH_PLAYERS_REJECTED";
export const FETCH_PLAYERS_FULFILLED = "FETCH_PLAYERS_FULFILLED";
/*-----/user team api/------*/
export const FETCH_USER_TEAM = "FETCH_USER_TEAM";
export const FETCH_USER_TEAM_PENDING = "FETCH_USER_TEAM_PENDING";
export const FETCH_USER_TEAM_REJECTED = "FETCH_USER_TEAM_REJECTED";
export const FETCH_USER_TEAM_FULFILLED = "FETCH_USER_TEAM_FULFILLED";
/*-----/revealed team api/------*/
export const FETCH_REVEALED_TEAM = "FETCH_REVEALED_TEAM";
export const FETCH_REVEALED_TEAM_PENDING = "FETCH_REVEALED_TEAM_PENDING";
export const FETCH_REVEALED_TEAM_REJECTED = "FETCH_REVEALED_TEAM_REJECTED";
export const FETCH_REVEALED_TEAM_FULFILLED = "FETCH_REVEALED_TEAM_FULFILLED";
/*-----/player card api/------*/
export const FETCH_PLAYER_CARD = "FETCH_PLAYER_CARD";
export const FETCH_PLAYER_CARD_PENDING = "FETCH_PLAYER_CARD_PENDING";
export const FETCH_PLAYER_CARD_REJECTED = "FETCH_PLAYER_CARD_REJECTED";
export const FETCH_PLAYER_CARD_FULFILLED = "FETCH_PLAYER_CARD_FULFILLED";
/*-----/save api/------*/
export const POST_SAVE_TEAM = "POST_SAVE_TEAM";
export const POST_SAVE_TEAM_PENDING = "POST_SAVE_TEAM_PENDING";
export const POST_SAVE_TEAM_REJECTED = "POST_SAVE_TEAM_REJECTED";
export const POST_SAVE_TEAM_FULFILLED = "POST_SAVE_TEAM_FULFILLED";
/*-----/login api/------*/
export const POST_LOGIN = "POST_LOGIN";
export const POST_LOGIN_PENDING = "POST_LOGIN_PENDING";
export const POST_LOGIN_REJECTED = "POST_LOGIN_REJECTED";
export const POST_LOGIN_FULFILLED = "POST_LOGIN_FULFILLED";
/*-----/get My11 login api/------*/
export const GET_My11_LOGIN = "GET_My11_LOGIN";
export const GET_My11_LOGIN_PENDING = "GET_My11_LOGIN_PENDING";
export const GET_My11_LOGIN_REJECTED = "GET_My11_LOGIN_REJECTED";
export const GET_My11_LOGIN_FULFILLED = "GET_My11_LOGIN_FULFILLED";
/*-----/post My11 logout api/------*/
export const POST_My11_LOGOUT = "POST_My11_LOGOUT";
export const POST_My11_LOGOUT_PENDING = "POST_My11_LOGOUT_PENDING";
export const POST_My11_LOGOUT_REJECTED = "POST_My11_LOGOUT_REJECTED";
export const POST_My11_LOGOUT_FULFILLED = "POST_My11_LOGOUT_FULFILLED";
/*-----/gdpr api/------*/
export const POST_GDPR = "POST_GDPR";
export const POST_GDPR_PENDING = "POST_GDPR_PENDING";
export const POST_GDPR_REJECTED = "POST_GDPR_REJECTED";
export const POST_GDPR_FULFILLED = "POST_GDPR_FULFILLED";
/* --------/stats api/------- */
export const FETCH_PLAYER_STATS = "FETCH_PLAYER_STATS";
export const FETCH_PLAYER_STATS_PENDING = "FETCH_PLAYER_STATS_PENDING";
export const FETCH_PLAYER_STATS_REJECTED = "FETCH_PLAYER_STATS_REJECTED";
export const FETCH_PLAYER_STATS_FULFILLED = "FETCH_PLAYER_STATS_FULFILLED";
/* -------/ Fav Team/ ------- */
export const FETCH_FAV_TEAM = "FETCH_FAV_TEAM";
export const FETCH_FAV_TEAM_PENDING = "FETCH_FAV_TEAM_PENDING";
export const FETCH_FAV_TEAM_REJECTED = "FETCH_FAV_TEAM_REJECTED";
export const FETCH_FAV_TEAM_FULFILLED = "FETCH_FAV_TEAM_FULFILLED";
/* ------/ Transfer History /------ */
export const FETCH_TRANSFER_HISTORY = "FETCH_TRANSFER_HISTORY";
export const FETCH_TRANSFER_HISTORY_PENDING = "FETCH_TRANSFER_HISTORY_PENDING";
export const FETCH_TRANSFER_HISTORY_REJECTED =
  "FETCH_TRANSFER_HISTORY_REJECTED";
export const FETCH_TRANSFER_HISTORY_FULFILLED =
  "FETCH_TRANSFER_HISTORY_FULFILLED";
/* -----/ Transfer History Players /-------- */
export const FETCH_TRANSFER_HISTORY_PLAYERS = "FETCH_TRANSFER_HISTORY_PLAYERS";
export const FETCH_TRANSFER_HISTORY_PLAYERS_PENDING =
  "FETCH_TRANSFER_HISTORY_PLAYERS_PENDING";
export const FETCH_TRANSFER_HISTORY_PLAYERS_REJECTED =
  "FETCH_TRANSFER_HISTORY_PLAYERS_REJECTED";
export const FETCH_TRANSFER_HISTORY_PLAYERS_FULFILLED =
  "FETCH_TRANSFER_HISTORY_PLAYERS_FULFILLED";
/* -----/ Player Statistics /------- */
export const FETCH_PLAYERS_STATS = "FETCH_PLAYERS_STATS";
export const FETCH_PLAYERS_STATS_PENDING = "FETCH_PLAYERS_STATS_PENDING";
export const FETCH_PLAYERS_STATS_REJECTED = "FETCH_PLAYERS_STATS_REJECTED";
export const FETCH_PLAYERS_STATS_FULFILLED = "FETCH_PLAYERS_STATS_FULFILLED";
/* -----/ Gamer Card / --------- */
export const FETCH_GAMERCARD = "FETCH_GAMERCARD";
export const FETCH_GAMERCARD_PENDING = "FETCH_GAMERCARD_PENDING";
export const FETCH_GAMERCARD_REJECTED = "FETCH_GAMERCARD_REJECTED";
export const FETCH_GAMERCARD_FULFILLED = "FETCH_GAMERCARD_FULFILLED";
/* ------/ Stats Widget /---------- */
export const FETCH_WIDGET = "FETCH_WIDGET";
export const FETCH_WIDGET_PENDING = "FETCH_WIDGET_PENDING";
export const FETCH_WIDGET_REJECTED = "FETCH_WIDGET_REJECTED";
export const FETCH_WIDGET_FULFILLED = "FETCH_WIDGET_FULFILLED";

export const ENABLE_DROP_MODE = "ENABLE_DROP_MODE";
export const DROP_ITEM = "DROP_ITEM";

export const CHANGE_MODE = "CHANGE_MODE";
export const RESET_TEAM = "RESET_TEAM";

export const SHOW_HIDE_POPUP = "SHOW_HIDE_POPUP";
export const CHANGE_FORMATION = "CHANGE_FORMATION";
export const AFTER_CHANGE_FORMATION = "AFTER_CHANGE_FORMATION";
export const CREATE_EMPTY_TEAM_BY_FORMATION = "CREATE_EMPTY_TEAM_BY_FORMATION";
export const CHANGE_SKILL_TAB = "CHANGE_SKILL_TAB";
export const ADD_PLAYER = "ADD_PLAYER";
export const REMOVE_PLAYER = "REMOVE_PLAYER";
export const SHOW_HIDE_PLAYERLISTING = "SHOW_HIDE_PLAYERLISTING";
export const ADD_REMOVED_PLAYER_FROM_FORMATION =
  "ADD_REMOVED_PLAYER_FROM_FORMATION";
export const REMOVE_REMOVED_PLAYER_FROM_FORMATION =
  "REMOVE_REMOVED_PLAYER_FROM_FORMATION";
export const ADD_PLAYER_FOR_CARD = "ADD_PLAYER_FOR_CARD";
export const REMOVE_PLAYER_FOR_CARD = "REMOVE_PLAYER_FOR_CARD";
export const SHOW_HIDE_OVERLAY = "SHOW_HIDE_OVERLAY";
//
export const CHANGE_FILTER_TAB = "CHANGE_FILTER_TAB";
export const CHANGE_FILTER_TAB_CHECKES = "CHANGE_FILTER_TAB_CHECKES";
export const APPLY_FILTER = "APPLY_FILTER";
export const RESET_FILTER = "RESET_FILTER";
export const CLOSE_FILTER = "CLOSE_FILTER";
export const CHANGE_SORT_BY = "CHANGE_SORT_BY";
export const CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION =
  "CHANGE_SKILL_TAB_AFTER_PLAYER_SELECTION";
export const CLEAR_PLAYER_SEARCH_ID = "CLEAR_PLAYER_SEARCH_ID";
export const CHANGE_PLAYER_CARD_TAB = "CHANGE_PLAYER_CARD_TAB";
export const ADD_REMOVE_PLAYER = "ADD_REMOVE_PLAYER";
export const SELECT_C_VC = "SELECT_C_VC";
export const CHANGE_SORT_BY_TEAM = "CHANGE_SORT_BY_TEAM";
export const CONTEST_APPLY_FILTER = "CONTEST_APPLY_FILTER";
export const CONTEST_RESET_FILTER = "CONTEST_RESET_FILTER";
export const CONTEST_CLOSE_FILTER = "CONTEST_CLOSE_FILTER";
export const CONTEST_CHANGE_FILTER_TAB_CHECKES =
  "CONTEST_CHANGE_FILTER_TAB_CHECKES";
export const CONTEST_CHANGE_FILTER_TAB = "CONTEST_CHANGE_FILTER_TAB";
/*-----/get public contest api/------*/
export const FETCH_PUBLIC_CONTEST = "FETCH_PUBLIC_CONTEST";
export const FETCH_PUBLIC_CONTEST_PENDING = "FETCH_PUBLIC_CONTEST_PENDING";
export const FETCH_PUBLIC_CONTEST_REJECTED = "FETCH_PUBLIC_CONTEST_REJECTED";
export const FETCH_PUBLIC_CONTEST_FULFILLED = "FETCH_PUBLIC_CONTEST_FULFILLED";
/*-----/get private contest api/------*/
export const FETCH_PRIVATE_CONTEST = "FETCH_PRIVATE_CONTEST";
export const FETCH_PRIVATE_CONTEST_PENDING = "FETCH_PRIVATE_CONTEST_PENDING";
export const FETCH_PRIVATE_CONTEST_REJECTED = "FETCH_PRIVATE_CONTEST_REJECTED";
export const FETCH_PRIVATE_CONTEST_FULFILLED =
  "FETCH_PRIVATE_CONTEST_FULFILLED";
/*-----/post create contest api/------*/
export const POST_CREATE_CONTEST = "POST_CREATE_CONTEST";
export const POST_CREATE_CONTEST_PENDING = "POST_CREATE_CONTEST_PENDING";
export const POST_CREATE_CONTEST_REJECTED = "POST_CREATE_CONTEST_REJECTED";
export const POST_CREATE_CONTEST_FULFILLED = "POST_CREATE_CONTEST_FULFILLED";
/*-----/post create contest api/------*/
export const POST_JOIN_CONTEST = "POST_JOIN_CONTEST";
export const POST_JOIN_CONTEST_PENDING = "POST_JOIN_CONTEST_PENDING";
export const POST_JOIN_CONTEST_REJECTED = "POST_JOIN_CONTEST_REJECTED";
export const POST_JOIN_CONTEST_FULFILLED = "POST_JOIN_CONTEST_FULFILLED";
/*-----/get contest leaderboard api/------*/
export const FETCH_CONTEST_LEADERBOARD = "FETCH_CONTEST_LEADERBOARD";
export const FETCH_CONTEST_LEADERBOARD_PENDING =
  "FETCH_CONTEST_LEADERBOARD_PENDING";
export const FETCH_CONTEST_LEADERBOARD_REJECTED =
  "FETCH_CONTEST_LEADERBOARD_REJECTED";
export const FETCH_CONTEST_LEADERBOARD_FULFILLED =
  "FETCH_CONTEST_LEADERBOARD_FULFILLED";
/*-----/get global leaderboard api/------*/
export const FETCH_GLOBAL_LEADERBOARD = "FETCH_GLOBAL_LEADERBOARD";
export const FETCH_GLOBAL_LEADERBOARD_PENDING =
  "FETCH_GLOBAL_LEADERBOARD_PENDING";
export const FETCH_GLOBAL_LEADERBOARD_REJECTED =
  "FETCH_GLOBAL_LEADERBOARD_REJECTED";
export const FETCH_GLOBAL_LEADERBOARD_FULFILLED =
  "FETCH_GLOBAL_LEADERBOARD_FULFILLED";
/*-----/get global leaderboard rank api/------*/
export const FETCH_GLOBAL_LIVE_RANK = "FETCH_GLOBAL_LIVE_RANK";
export const FETCH_GLOBAL_LIVE_RANK_PENDING = "FETCH_GLOBAL_LIVE_RANK_PENDING";
export const FETCH_GLOBAL_LIVE_RANK_REJECTED =
  "FETCH_GLOBAL_LIVE_RANK_REJECTED";
export const FETCH_GLOBAL_LIVE_RANK_FULFILLED =
  "FETCH_GLOBAL_LIVE_RANK_FULFILLED";
/*-----/get favourite team leaderboard api/------*/
export const FETCH_FAVTEAM_LEADERBOARD = "FETCH_FAVTEAM_LEADERBOARD";
export const FETCH_FAVTEAM_LEADERBOARD_PENDING =
  "FETCH_FAVTEAM_LEADERBOARD_PENDING";
export const FETCH_FAVTEAM_LEADERBOARD_REJECTED =
  "FETCH_FAVTEAM_LEADERBOARD_REJECTED";
export const FETCH_FAVTEAM_LEADERBOARD_FULFILLED =
  "FETCH_FAVTEAM_LEADERBOARD_FULFILLED";
/*-----/get favourite team leaderboard rank api/------*/
export const FETCH_FAVTEAM_LIVE_RANK = "FETCH_FAVTEAM_LIVE_RANK";
export const FETCH_FAVTEAM_LIVE_RANK_PENDING =
  "FETCH_FAVTEAM_LIVE_RANK_PENDING";
export const FETCH_FAVTEAM_LIVE_RANK_REJECTED =
  "FETCH_FAVTEAM_LIVE_RANK_REJECTED";
export const FETCH_FAVTEAM_LIVE_RANK_FULFILLED =
  "FETCH_FAVTEAM_LIVE_RANK_FULFILLED";

/*-----/get captain leaderboard api/------*/
export const FETCH_CAPTAIN_LEADERBOARD = "FETCH_CAPTAIN_LEADERBOARD";
export const FETCH_CAPTAIN_LEADERBOARD_PENDING =
  "FETCH_CAPTAIN_LEADERBOARD_PENDING";
export const FETCH_CAPTAIN_LEADERBOARD_REJECTED =
  "FETCH_CAPTAIN_LEADERBOARD_REJECTED";
export const FETCH_CAPTAIN_LEADERBOARD_FULFILLED =
  "FETCH_CAPTAIN_LEADERBOARD_FULFILLED";
/*-----/get captain leaderboard rank api/------*/
export const FETCH_CAPTAIN_LIVE_RANK = "FETCH_CAPTAIN_LIVE_RANK";
export const FETCH_CAPTAIN_LIVE_RANK_PENDING =
  "FETCH_CAPTAIN_LIVE_RANK_PENDING";
export const FETCH_CAPTAIN_LIVE_RANK_REJECTED =
  "FETCH_CAPTAIN_LIVE_RANK_REJECTED";
export const FETCH_CAPTAIN_LIVE_RANK_FULFILLED =
  "FETCH_CAPTAIN_LIVE_RANK_FULFILLED";
/*-----/get vice captain leaderboard api/------*/
export const FETCH_VICE_CAPTAIN_LEADERBOARD = "FETCH_VICE_CAPTAIN_LEADERBOARD";
export const FETCH_VICE_CAPTAIN_LEADERBOARD_PENDING =
  "FETCH_VICE_CAPTAIN_LEADERBOARD_PENDING";
export const FETCH_VICE_CAPTAIN_LEADERBOARD_REJECTED =
  "FETCH_VICE_CAPTAIN_LEADERBOARD_REJECTED";
export const FETCH_VICE_CAPTAIN_LEADERBOARD_FULFILLED =
  "FETCH_VICE_CAPTAIN_LEADERBOARD_FULFILLED";
/*-----/get vice captain leaderboard rank api/------*/
export const FETCH_VICE_CAPTAIN_LIVE_RANK = "FETCH_VICE_CAPTAIN_LIVE_RANK";
export const FETCH_VICE_CAPTAIN_LIVE_RANK_PENDING =
  "FETCH_VICE_CAPTAIN_LIVE_RANK_PENDING";
export const FETCH_VICE_CAPTAIN_LIVE_RANK_REJECTED =
  "FETCH_VICE_CAPTAIN_LIVE_RANK_REJECTED";
export const FETCH_VICE_CAPTAIN_LIVE_RANK_FULFILLED =
  "FETCH_VICE_CAPTAIN_LIVE_RANK_FULFILLED";
/*-----/get vice captain new joinee api/------*/
export const FETCH_CONTEST_NEWJOINEE = "FETCH_CONTEST_NEWJOINEE";
export const FETCH_CONTEST_NEWJOINEE_PENDING =
  "FETCH_CONTEST_NEWJOINEE_PENDING";
export const FETCH_CONTEST_NEWJOINEE_REJECTED =
  "FETCH_CONTEST_NEWJOINEE_REJECTED";
export const FETCH_CONTEST_NEWJOINEE_FULFILLED =
  "FETCH_CONTEST_NEWJOINEE_FULFILLED";

/*-----/get Knockout leaderboard api/------*/
export const FETCH_KNOCKOUT_LEADERBOARD = "FETCH_KNOCKOUT_LEADERBOARD";
export const FETCH_KNOCKOUT_LEADERBOARD_PENDING =
  "FETCH_KNOCKOUT_LEADERBOARD_PENDING";
export const FETCH_KNOCKOUT_LEADERBOARD_REJECTED =
  "FETCH_KNOCKOUT_LEADERBOARD_REJECTED";
export const FETCH_KNOCKOUT_LEADERBOARD_FULFILLED =
  "FETCH_KNOCKOUT_LEADERBOARD_FULFILLED";
/*-----/get KNOCKOUT leaderboard rank api/------*/
export const FETCH_KNOCKOUT_LIVE_RANK = "FETCH_KNOCKOUT_LIVE_RANK";
export const FETCH_KNOCKOUT_LIVE_RANK_PENDING =
  "FETCH_KNOCKOUT_LIVE_RANK_PENDING";
export const FETCH_KNOCKOUT_LIVE_RANK_REJECTED =
  "FETCH_KNOCKOUT_LIVE_RANK_REJECTED";
export const FETCH_KNOCKOUT_LIVE_RANK_FULFILLED =
  "FETCH_KNOCKOUT_LIVE_RANK_FULFILLED";

/*-----/get comparison api/------*/
export const FETCH_TEAM_COMPARISON = "FETCH_TEAM_COMPARISON";
export const FETCH_TEAM_COMPARISON_PENDING = "FETCH_TEAM_COMPARISON_PENDING";
export const FETCH_TEAM_COMPARISON_REJECTED = "FETCH_TEAM_COMPARISON_REJECTED";
export const FETCH_TEAM_COMPARISON_FULFILLED =
  "FETCH_TEAM_COMPARISON_FULFILLED";
/*-----/set leaderboard last updated time/------*/
export const SET_LAST_UPDATED_TIME = "SET_LAST_UPDATED_TIME";
/*-----/clear leaderboard data/------*/
export const RESET_CONTEST_LEADERBOARD_DATA = "RESET_CONTEST_LEADERBOARD_DATA";

export const CHANGE_SELECTED_FIXTURE = "CHANGE_SELECTED_FIXTURE";

/*-----/get userPlayedGameDays api/------*/
export const FETCH_USER_PLAYED_GAMEDAYS = "FETCH_USER_PLAYED_GAMEDAYS";
export const FETCH_USER_PLAYED_GAMEDAYS_PENDING =
  "FETCH_USER_PLAYED_GAMEDAYS_PENDING";
export const FETCH_USER_PLAYED_GAMEDAYS_REJECTED =
  "FETCH_USER_PLAYED_GAMEDAYS_REJECTED";
export const FETCH_USER_PLAYED_GAMEDAYS_FULFILLED =
  "FETCH_USER_PLAYED_GAMEDAYS_FULFILLED";

/*-----/transfer api/------*/
export const POST_TRANSFER_TEAM = "POST_TRANSFER_TEAM";
export const POST_TRANSFER_TEAM_PENDING = "POST_TRANSFER_TEAM_PENDING";
export const POST_TRANSFER_TEAM_REJECTED = "POST_TRANSFER_TEAM_REJECTED";
export const POST_TRANSFER_TEAM_FULFILLED = "POST_TRANSFER_TEAM_FULFILLED";

/*-----/captain api/------*/
export const POST_CAPTAIN_TEAM = "POST_CAPTAIN_TEAM";
export const POST_CAPTAIN_TEAM_PENDING = "POST_CAPTAIN_TEAM_PENDING";
export const POST_CAPTAIN_TEAM_REJECTED = "POST_CAPTAIN_TEAM_REJECTED";
export const POST_CAPTAIN_TEAM_FULFILLED = "POST_CAPTAIN_TEAM_FULFILLED";

/*-----/get Myteam api/------*/
export const FETCH_USER_TEAM_LIST = "FETCH_USER_TEAM_LIST";
export const FETCH_USER_TEAM_LIST_PENDING = "FETCH_USER_TEAM_LIST_PENDING";
export const FETCH_USER_TEAM_LIST_REJECTED = "FETCH_USER_TEAM_LIST_REJECTED";
export const FETCH_USER_TEAM_LIST_FULFILLED = "FETCH_USER_TEAM_LIST_FULFILLED";

export const CHANGE_SELECTED_TEAM = "CHANGE_SELECTED_TEAM";

/*-----/players live api/------*/
export const FETCH_PLAYERS_LIVE = "FETCH_PLAYERS_LIVE";
export const FETCH_PLAYERS_LIVE_PENDING = "FETCH_PLAYERS_LIVE_PENDING";
export const FETCH_PLAYERS_LIVE_REJECTED = "FETCH_PLAYERS_LIVE_REJECTED";
export const FETCH_PLAYERS_LIVE_FULFILLED = "FETCH_PLAYERS_LIVE_FULFILLED";
/*-----/other user team api/------*/
export const FETCH_OTHER_USER_TEAM = "FETCH_OTHER_USER_TEAM";
export const FETCH_OTHER_USER_TEAM_PENDING = "FETCH_OTHER_USER_TEAM_PENDING";
export const FETCH_OTHER_USER_TEAM_REJECTED = "FETCH_OTHER_USER_TEAM_REJECTED";
export const FETCH_OTHER_USER_TEAM_FULFILLED =
  "FETCH_OTHER_USER_TEAM_FULFILLED";
export const UPCOMING_FIXTURE = "UPCOMING_FIXTURE";
/*-----/live mix api/------*/
export const FETCH_MIX = "FETCH_MIX";
export const FETCH_MIX_PENDING = "FETCH_MIX_PENDING";
export const FETCH_MIX_REJECTED = "FETCH_MIX_REJECTED";
export const FETCH_MIX_FULFILLED = "FETCH_MIX_FULFILLED";
/* -------/ USER PLAYER STATS/ --------- */
export const FETCH_USER_STATS_PLAYER = "FETCH_USER_STATS_PLAYER";
export const FETCH_USER_STATS_PLAYER_PENDING =
  "FETCH_USER_STATS_PLAYER_PENDING";
export const FETCH_USER_STATS_PLAYER_REJECTED =
  "FETCH_USER_STATS_PLAYER_REJECTED";
export const FETCH_USER_STATS_PLAYER_FULFILLED =
  "FETCH_USER_STATS_PLAYER_FULFILLED";

/* -------/ GET BOOSTERS/ --------- */
export const FETCH_BOOSTERS_CONTRAINTS = "FETCH_BOOSTERS_CONTRAINTS";
export const FETCH_BOOSTERS_CONTRAINTS_PENDING =
  "FETCH_BOOSTERS_CONTRAINTS_PENDING";
export const FETCH_BOOSTERS_CONTRAINTS_REJECTED =
  "FETCH_BOOSTERS_CONTRAINTS_REJECTED";
export const FETCH_BOOSTERS_CONTRAINTS_FULFILLED =
  "FETCH_BOOSTERS_CONTRAINTS_FULFILLED";

export const IS_SHOW_MENU = "IS_SHOW_MENU";
export const IS_HEADER_DATA = "IS_HEADER_DATA";
export const CHANGE_BOOSTER = "CHANGE_BOOSTER";
export const CHANGE_REMOVE_PLAYER = "CHANGE_REMOVE_PLAYER";

/* -------/ GET BADGES/ --------- */

export const FETCH_BADGES = "FETCH_BADGES";
export const FETCH_BADGES_PENDING = "FETCH_BADGES_PENDING";
export const FETCH_BADGES_REJECTED = "FETCH_BADGES_REJECTED";
export const FETCH_BADGES_FULFILLED = "FETCH_BADGES_FULFILLED";

/* -------/ POST Remove League / --------- */
export const POST_REMOVE_LEAGUE = "POST_REMOVE_LEAGUE";
export const POST_REMOVE_LEAGUE_PENDING = "POST_REMOVE_LEAGUE_PENDING";
export const POST_REMOVE_LEAGUE_REJECTED = "POST_REMOVE_LEAGUE_REJECTED";
export const POST_REMOVE_LEAGUE_FULFILLED = "POST_REMOVE_LEAGUE_FULFILLED";

/* -------/ Fetch User Badges / --------- */
export const FETCH_USER_BADGES = "FETCH_USER_BADGES";
export const FETCH_USER_BADGES_PENDING = "FETCH_USER_BADGES_PENDING";
export const FETCH_USER_BADGES_REJECTED = "FETCH_USER_BADGES_REJECTED";
export const FETCH_USER_BADGES_FULFILLED = "FETCH_USER_BADGES_FULFILLED";

export const UPDATE_UNLOCKED_BADGES = "UPDATE_UNLOCKED_BADGES";

/* -------/ POST BADGE NOTIFICATION / --------- */
export const POST_SAVE_BADGE_NOTIFY = "POST_SAVE_BADGE_NOTIFY";
export const POST_SAVE_BADGE_NOTIFY_PENDING = "POST_SAVE_BADGE_NOTIFY_PENDING";
export const POST_SAVE_BADGE_NOTIFY_REJECTED =
  "POST_SAVE_BADGE_NOTIFY_REJECTED";
export const POST_SAVE_BADGE_NOTIFY_FULFILLED =
  "POST_SAVE_BADGE_NOTIFY_FULFILLED";

/* -------/ Update User Badges / --------- */
export const UPDATE_USER_BADGES = "UPDATE_USER_BADGES";

export const SET_WRAPPER = "SET_WRAPPER";
export const UPDATE_UNLOCKED_BADGES_TEAM = "UPDATE_UNLOCKED_BADGES_TEAM";
export const RESET_STORE = "RESET_STORE";
export const FETCH_USER_BADGES_AFTER_POINT_CAL =
  "FETCH_USER_BADGES_AFTER_POINT_CAL";
export const FETCH_USER_BADGES_AFTER_POINT_CAL_PENDING =
  "FETCH_USER_BADGES_AFTER_POINT_CAL_PENDING";
export const FETCH_USER_BADGES_AFTER_POINT_CAL_REJECTED =
  "FETCH_USER_BADGES_AFTER_POINT_CAL_REJECTED";
export const FETCH_USER_BADGES_AFTER_POINT_CAL_FULFILLED =
  "FETCH_USER_BADGES_AFTER_POINT_CAL_FULFILLED";
export const SHOW_HIDE_PULLTO_REFRESH = "SHOW_HIDE_PULLTO_REFRESH";

export const AKAMAI_TIMER_CALL = "AKAMAI_TIMER_CALL";
export const AKAMAI_TIMER_CALL_PENDING = "AKAMAI_TIMER_CALL_PENDING";
export const AKAMAI_TIMER_CALL_REJECTED = "AKAMAI_TIMER_CALL_REJECTED";
export const AKAMAI_TIMER_CALL_FULFILLED = "AKAMAI_TIMER_CALL_FULFILLED";

// MY PROFILE CHANGES

export const POST_TEAM_NAME_SUBMIT = "POST_TEAM_NAME_SUBMIT";
export const POST_TEAM_NAME_SUBMIT_PENDING = "POST_TEAM_NAME_SUBMIT_PENDING";
export const POST_TEAM_NAME_SUBMIT_REJECTED = "POST_TEAM_NAME_SUBMIT_REJECTED";
export const POST_TEAM_NAME_SUBMIT_FULFILLED =
  "POST_TEAM_NAME_SUBMIT_FULFILLED";

export const FETCH_CTR_FAV_DATA = "FETCH_CTR_FAV_DATA";
export const FETCH_CTR_FAV_DATA_PENDING = "FETCH_CTR_FAV_DATA_PENDING";
export const FETCH_CTR_FAV_DATA_REJECTED = "FETCH_CTR_FAV_DATA_REJECTED";
export const FETCH_CTR_FAV_DATA_FULFILLED = "FETCH_CTR_FAV_DATA_FULFILLED";

export const POST_PROFILE_UPDATE_SUBMIT = "POST_PROFILE_UPDATE_SUBMIT";
export const POST_PROFILE_UPDATE_SUBMIT_PENDING =
  "POST_PROFILE_UPDATE_SUBMIT_PENDING";
export const POST_PROFILE_UPDATE_SUBMIT_REJECTED =
  "POST_PROFILE_UPDATE_SUBMIT_REJECTED";
export const POST_PROFILE_UPDATE_SUBMIT_FULFILLED =
  "POST_PROFILE_UPDATE_SUBMIT_FULFILLED";

export const FETCH_PROFILE_DATA = "FETCH_PROFILE_DATA";
export const FETCH_PROFILE_DATA_PENDING = "FETCH_PROFILE_DATA_PENDING";
export const FETCH_PROFILE_DATA_REJECTED = "FETCH_PROFILE_DATA_REJECTED";
export const FETCH_PROFILE_DATA_FULFILLED = "FETCH_PROFILE_DATA_FULFILLED";

export const SHOULD_DELETE_BOOSTER = "SHOULD_DELETE_BOOSTER";

export const FETCH_CONFIG_DATA = "FETCH_CONFIG_DATA";
export const FETCH_CONFIG_DATA_PENDING = "FETCH_CONFIG_DATA_PENDING";
export const FETCH_CONFIG_DATA_REJECTED = "FETCH_CONFIG_DATA_REJECTED";
export const FETCH_CONFIG_DATA_FULFILLED = "FETCH_CONFIG_DATA_FULFILLED";

export const FETCH_USER_POINTS_HISTORY = "FETCH_USER_POINTS_HISTORY";
export const FETCH_USER_POINTS_HISTORY_PENDING =
  "FETCH_USER_POINTS_HISTORY_PENDING";
export const FETCH_USER_POINTS_HISTORY_REJECTED =
  "FETCH_USER_POINTS_HISTORY_REJECTED";
export const FETCH_USER_POINTS_HISTORY_FULFILLED = "FETCH_USER_TEAM_FULFILLED";

export const GET_MY_RANK = "GET_MY_RANK";

export const VIEW_TEAM = "VIEW_TEAM";

export const BOOSTER_RESET = "BOOSTER_RESET";
